<template>
  <div class="login-container">
    <div class="login-container__layout">
      <div
        v-if="cartTotalItems"
        class="login-container__form"
      >
        <LoginForm
          :caption="$t('Log in & checkout')"
          @click-forgot-password="goToResetPassword"
        />
      </div>
      <CartPreview
        v-else
        class="mt-10 lg:w-2/3"
        @click-back="$router.push('/')"
      />
      <div
        v-if="canShowContent"
        class="login-container__promo"
      >
        <RenderContent :content="internalCmsContent" />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Logger } from '~~/helpers/logger';
import { cartGetters, useUser } from '~/utils/ct';

import RenderContent from '~/cms/RenderContent.vue';
import { COMPONENTS } from '~~/constants/cms';
import { ROUTES } from '~~/constants/routes';
import CartPreview from '~/components/organisms/Cart/CartPreview.vue';
import LoginForm from '~/components/organisms/LoginForm/LoginForm.vue';

definePageMeta({
  layout: 'no-footer-layout',
});

export default defineComponent({
  name: 'CheckoutLogin',
  components: {
    CartPreview,
    LoginForm,
    RenderContent,
  },
  setup() {

    const { clientEmail, setClientEmail } = useClientEmailStore();
    const { isAuthenticated } = useUser();
    const { getAdjustedSlug } = useRouteExtended();
    const { setEmail } = useCiaState();

    const guestEmail = ref(clientEmail);

    const redirectToNextStep = () => {

      return navigateTo(getAdjustedSlug(ROUTES.CHECKOUT_ADDRESSES));

    };

    const goToResetPassword = () => navigateTo(resetPasswordSlug.value);

    const handleGuestSubmit = () => {

      if (guestEmail.value) {

        setClientEmail(guestEmail.value);

      }
      try {

        setEmail(guestEmail?.value || '');

      } catch (error) {

        Logger.error(`cia|setEmail error: ${error}`);

      }

      return redirectToNextStep();

    };

    const { cart } = useCartExtended();
    const cartTotalItems = computed(() => cartGetters.getTotalItems(cart.value));

    const rerouteAuthenticatedUser = () => {

      if (cartTotalItems.value && isAuthenticated.value) {

        return redirectToNextStep();

      }

    };

    const {
      loadComponent,
      canShowContent,
      internalCmsContent,
    } = useInternalCms(COMPONENTS.CREATE_ACCOUNT_PROMO.SLUG);

    const resetPasswordSlug = computed(() => getAdjustedSlug(ROUTES.RESET_PASSWORD));

    useAsyncData(`cms-${COMPONENTS.CREATE_ACCOUNT_PROMO.SLUG}`, async () => {

      const navigationResult = rerouteAuthenticatedUser();

      if (navigationResult) {

        return navigationResult;

      }

      await loadComponent();

      return '';

    });

    watch(isAuthenticated, rerouteAuthenticatedUser);

    return {
      cartTotalItems,
      guestEmail,
      goToResetPassword,
      handleGuestSubmit,
      isAuthenticated,
      ROUTES,
      resetPasswordSlug,
      canShowContent,
      internalCmsContent,
    };

  },
});
</script>

<style lang="scss" scoped>
.login-container {
  @apply mb-10;
}

.login-container__layout {
  @apply lg:flex  lg:space-x-10;
}

.login-container__form {
  @apply my-7 lg:w-1/2;
}

.login-container__promo {
  @apply my-7 lg:w-1/2;
}
</style>
